import { useMemo } from 'react';
import { cn } from '@restworld/utils-common';

export interface ProgressBarProps {
  /** Progress percentage (0-100) */
  percent: number;
  /** Additional classes for the track (background bar) */
  trackClassName?: string;
  /** Additional classes for the indicator (filled bar) */
  indicatorClassName?: string;
}

export function ProgressBar({ percent, trackClassName, indicatorClassName }: ProgressBarProps) {
  const width = useMemo(() => Math.min(100, Math.max(0, percent)), [percent]);

  return (
    <div className={cn('h-1.5 w-full rounded-sm bg-gray-200', trackClassName)}>
      <div className={cn('h-1.5 rounded-sm bg-primary-700', indicatorClassName)} style={{ width: `${width}%` }} />
    </div>
  );
}
